import { lazy } from 'react';
import { lazyLoad } from '../utils/lazyLoad';
import { createBrowserRouter } from 'react-router-dom';
import { ProtectedModuleRoutes, ProtectedRoute } from './PrivateRoutes';
const PurchaseExcelUpload = lazy(
	() => import('../features/purchaseEntry/pages/PurchaseExcelUpload')
);
const ProductRepairing = lazy(() => import('../features/productRepairing/pages/ProductRepairing'));
const Layout = lazy(() => import('../components/layout/Layout'));
const Dashboard = lazy(() => import('../features/auth/pages/Dashboard'));
const Login = lazy(() => import('../features/auth/pages/Login'));
const AccountDetails = lazy(() => import('../features/master/pages/AccountDetails'));
const SalesmanCreation = lazy(() => import('../features/master/pages/SalesmanCreation'));
const CommisionCreation = lazy(() => import('../features/master/pages/CommisionCreation'));
const AddPrinter = lazy(() => import('../features/master/pages/AddPrinter'));
const FirmCreation = lazy(() => import('../features/master/pages/FirmCreation'));
const MasterEntry = lazy(() => import('../features/master/pages/MasterEntry'));
const UserCreation = lazy(() => import('../features/master/pages/UserCreation'));
const BarcodeReport = lazy(() => import('../features/reports/pages/BarcodeReport'));
const DeadStockReport = lazy(() => import('../features/reports/pages/DeadStockReport'));
const MiniStockReport = lazy(() => import('../features/reports/pages/MiniStockReport'));
const OrderReport = lazy(() => import('../features/reports/pages/OrderReport'));
const PaymentReport = lazy(() => import('../features/reports/pages/PaymentReport'));
const SalesReport = lazy(() => import('../features/reports/pages/SalesReport'));
const SalesReturnReport = lazy(() => import('../features/reports/pages/SalesReturnReport'));
const StockReport = lazy(() => import('../features/reports/pages/StockReport'));
const SalesManReport = lazy(() => import('../features/reports/pages/SalesManReport'));
const TSalesBill = lazy(() => import('../features/salesBill/pages/TSalesBill'));
const SalesReturn = lazy(() => import('../features/salesReturn/pages/SalesReturn'));
const ProductCreation = lazy(() => import('../features/productCreation/pages/ProductCreation'));
const BasicTools = lazy(() => import('../features/reports/pages/BasicTools'));
const BarcodeScanner = lazy(() => import('../features/reports/pages/BarcodeScanner'));
const BarcodeScannerReport = lazy(() => import('../features/reports/pages/BarcodeScannerReport'));
const PurchaseReport = lazy(() => import('../features/purchaseEntry/pages/PurchaseReport'));
const Transaction = lazy(() => import('../features/purchaseEntry/pages/Transaction'));
const Draft = lazy(() => import('../features/purchaseEntry/pages/PurchaseDraft'));
const licensePage = lazy(() => import('../features/master/pages/license/ActivateLicense'));
const license = lazy(() => import('../features/master/pages/license/License'));
const UserSettings = lazy(() => import('../features/master/pages/UserSettings'));
const Transfer = lazy(() => import('../features/stockTransfer/pages/Transfer'));
const TransferHistory = lazy(() => import('../features/stockTransfer/pages/TransferHistory'));
const TransferList = lazy(() => import('../features/stockTransfer/pages/TransferList'));
const Notifications = lazy(() => import('../features/notifications/page/Notifications'));
const PurchaseExcelUploadTemp2 = lazy(
	() => import('../features/purchaseEntry/pages/PurchseExcelUploadTemp2')
);

const router = createBrowserRouter(
	[
		{
			path: '/',
			element: (
				<ProtectedRoute>
					<Layout />
				</ProtectedRoute>
			),
			children: [
				{
					index: true,
					element: (
						<ProtectedModuleRoutes requiredModule='Dashboard'>
							{lazyLoad(Dashboard)}
						</ProtectedModuleRoutes>
					),
				},
				{
					path: 'master',
					children: [
						{
							path: 'master-entry',
							element: (
								<ProtectedModuleRoutes requiredModule='MasterEntry'>
									{lazyLoad(MasterEntry)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Master Entry' },
						},
						{
							path: 'user-creation',
							element: (
								<ProtectedModuleRoutes requiredModule='UserCreation'>
									{lazyLoad(UserCreation)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'User Creation' },
						},
						{
							path: 'user-settings',
							element: (
								<ProtectedModuleRoutes requiredModule='UserSettings'>
									{lazyLoad(UserSettings)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'User Settings' },
						},
						{
							path: 'firm-creation',
							element: (
								<ProtectedModuleRoutes requiredModule='FirmCreation'>
									{lazyLoad(FirmCreation)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Firm Creation' },
						},
						{
							path: 'add-printer',
							element: (
								<ProtectedModuleRoutes requiredModule='AddPrinter'>
									{lazyLoad(AddPrinter)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Add Printer' },
						},
						{
							path: 'account-details',
							element: (
								<ProtectedModuleRoutes requiredModule='AccountDetails'>
									{lazyLoad(AccountDetails)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Account Details' },
						},
						{
							path: 'salesman-creation',
							element: (
								<ProtectedModuleRoutes requiredModule='SalesmanCreation'>
									{lazyLoad(SalesmanCreation)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Account Details' },
						},
						{
							path: 'commision-creation',
							element: (
								<ProtectedModuleRoutes requiredModule='CommisionCreation'>
									{lazyLoad(CommisionCreation)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Commision Creation' },
						},
					],
				},
				{
					path: 'supplier-creation',
					element: (
						<ProtectedModuleRoutes requiredModule='SupplierCreation'>
							{lazyLoad(ProductCreation)}
						</ProtectedModuleRoutes>
					),
					handle: { pageName: 'Purchase' },
				},
				{
					path: 'purchase',
					children: [
						{
							path: 'transaction',
							element: (
								<ProtectedModuleRoutes requiredModule='PurchaseInvoice'>
									{lazyLoad(Transaction)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Purchase Invoice' },
						},
						{
							path: 'excel-transaction',
							element: (
								<ProtectedModuleRoutes requiredModule='PurchaseExcelUpload'>
									{lazyLoad(PurchaseExcelUpload)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Purchase Excel Upload' },
						},
						{
							path: 'excel-transaction-temp-2',
							element: (
								<ProtectedModuleRoutes requiredModule='PurchaseExcelUploadTemp2'>
									{lazyLoad(PurchaseExcelUploadTemp2)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Purchase Excel Upload' },
						},
						{
							path: 'draft',
							element: (
								<ProtectedModuleRoutes requiredModule='PurchaseDraft'>
									{lazyLoad(Draft)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Purchase Draft' },
						},
					],
				},
				{
					path: 'report',
					children: [
						{
							path: 'purchase-report',
							element: (
								<ProtectedModuleRoutes requiredModule='PurchaseReport'>
									{lazyLoad(PurchaseReport)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Purchase Report' },
						},
						{
							path: 'sales-report',
							element: (
								<ProtectedModuleRoutes requiredModule='SalesReport'>
									{lazyLoad(SalesReport)}
								</ProtectedModuleRoutes>
							),
						},
						{
							path: 'barcode-report',
							element: (
								<ProtectedModuleRoutes requiredModule='BarcodeReport'>
									{lazyLoad(BarcodeReport)}
								</ProtectedModuleRoutes>
							),
						},
						{
							path: 'dead-stock-report',
							element: (
								<ProtectedModuleRoutes requiredModule='DeadStockReport'>
									{lazyLoad(DeadStockReport)}
								</ProtectedModuleRoutes>
							),
						},
						{
							path: 'mini-stock-report',
							element: (
								<ProtectedModuleRoutes requiredModule='MiniStockReport'>
									{lazyLoad(MiniStockReport)}
								</ProtectedModuleRoutes>
							),
						},
						{
							path: 'payment-report',
							element: (
								<ProtectedModuleRoutes requiredModule='PaymentReport'>
									{lazyLoad(PaymentReport)}
								</ProtectedModuleRoutes>
							),
						},
						{
							path: 'sales-return-report',
							element: (
								<ProtectedModuleRoutes requiredModule='SalesReturnReport'>
									{lazyLoad(SalesReturnReport)}
								</ProtectedModuleRoutes>
							),
						},
						{
							path: 'stock-report',
							element: (
								<ProtectedModuleRoutes requiredModule='StockReport'>
									{lazyLoad(StockReport)}
								</ProtectedModuleRoutes>
							),
						},
						{
							path: 'order-report',
							element: (
								<ProtectedModuleRoutes requiredModule='OrderReport'>
									{lazyLoad(OrderReport)}
								</ProtectedModuleRoutes>
							),
						},
						{
							path: 'barcode-scanner',
							element: (
								<ProtectedModuleRoutes requiredModule='BarcodeScanner'>
									{lazyLoad(BarcodeScanner)}
								</ProtectedModuleRoutes>
							),
						},
						{
							path: 'barcode-scanner-report',
							element: (
								<ProtectedModuleRoutes requiredModule='BarcodeScannerReport'>
									{lazyLoad(BarcodeScannerReport)}
								</ProtectedModuleRoutes>
							),
						},
						{
							path: 'salesman-report',
							element: (
								<ProtectedModuleRoutes requiredModule='SalesManReport'>
									{lazyLoad(SalesManReport)}
								</ProtectedModuleRoutes>
							),
						},
					],
				},
				{
					path: 'product-repairing',
					element: (
						<ProtectedModuleRoutes requiredModule='ProductRepairing'>
							{lazyLoad(ProductRepairing)}
						</ProtectedModuleRoutes>
					),
					handle: { pageName: 'product-repairing' },
				},
				{
					path: 'basic-tools',
					element: (
						<ProtectedModuleRoutes requiredModule='Basic Tools'>
							{lazyLoad(BasicTools)}
						</ProtectedModuleRoutes>
					),
					handle: { pageName: 'Basic Tools' },
				},
				{
					path: 'billing-table',
					element: (
						<ProtectedModuleRoutes requiredModule='SalesBill'>
							{lazyLoad(TSalesBill)}
						</ProtectedModuleRoutes>
					),
					handle: { pageName: 'Billing Table' },
				},
				{
					path: 'sales-return',
					element: (
						<ProtectedModuleRoutes requiredModule='SalesReturn'>
							{lazyLoad(SalesReturn)}
						</ProtectedModuleRoutes>
					),
					handle: { pageName: 'Sales Return' },
				},
				{
					path: 'notifications',
					element: <>{lazyLoad(Notifications)}</>,
					handle: { pageName: 'Notifications' },
				},
				{
					path: 'stock-transfer',
					children: [
						{
							path: 'transfer',
							element: (
								<ProtectedModuleRoutes requiredModule='Transfer'>
									{lazyLoad(Transfer)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Transfer' },
						},
						{
							path: 'transfer-list',
							element: (
								<ProtectedModuleRoutes requiredModule='TransferList'>
									{lazyLoad(TransferList)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Transfer List' },
						},
						{
							path: 'transfer-history',
							element: (
								<ProtectedModuleRoutes requiredModule='TransferHistory'>
									{lazyLoad(TransferHistory)}
								</ProtectedModuleRoutes>
							),
							handle: { pageName: 'Transfer History' },
						},
					],
				},
			],
		},
		{
			path: '/login',
			element: lazyLoad(Login),
		},
		{
			path: '/license',
			element: lazyLoad(licensePage),
		},
		{
			path: '/licenseadmin',
			element: lazyLoad(license),
		},
	],
	{
		future: {
			v7_startTransition: true, //It aligns code with React Router v7's upcoming behavior.
		},
	}
);

export default router;
